import { render, staticRenderFns } from "./ContactFloatButton.vue?vue&type=template&id=25045178&scoped=true&lang=pug"
import script from "./ContactFloatButton.vue?vue&type=script&lang=js"
export * from "./ContactFloatButton.vue?vue&type=script&lang=js"
import style0 from "./ContactFloatButton.vue?vue&type=style&index=0&id=25045178&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25045178",
  null
  
)

export default component.exports